module.exports = __webpack_public_path__ + "img/popular-man.3934a750.png";